var React = require('react');

function PhoneInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.2074 0H5.79258C4.98724 0 4.33714 0.620363 4.33714 1.38405V17.6173C4.33714 18.3803 4.98724 19 5.79258 19H14.2074C15.0113 19 15.6628 18.3803 15.6628 17.6173V1.38405C15.6628 0.620363 15.0113 0 14.2074 0ZM7.92362 0.840536H12.0778C12.1828 0.840536 12.2681 0.989396 12.2681 1.17357C12.2681 1.35774 12.1828 1.50729 12.0778 1.50729H7.92362C7.81794 1.50729 7.73413 1.35774 7.73413 1.17357C7.73413 0.989396 7.81794 0.840536 7.92362 0.840536ZM10.0007 17.634C9.48837 17.634 9.07149 17.2379 9.07149 16.7505C9.07149 16.2631 9.48837 15.8684 10.0007 15.8684C10.5116 15.8684 10.9285 16.2631 10.9285 16.7505C10.9285 17.2379 10.5116 17.634 10.0007 17.634ZM14.5725 14.609H5.42817V2.33536H14.5725V14.609Z","fill":"#FF0000"}));
}

PhoneInline.defaultProps = {"width":"20","height":"19","viewBox":"0 0 20 19","fill":"none"};

module.exports = PhoneInline;

PhoneInline.default = PhoneInline;
